import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { PostUbsHealthPromotionSmsEmailRequest } from '../../requests/srv-email/post-ubs-health-promotion-sms-email.request';

@Injectable({
  providedIn: 'root' 
})
export class UbsHealthPromotionSmsEmailService extends CommonService{

  constructor(private router: Router,
    private httpClient: HttpClient,) {
    super();
  }

  public sendSmsEmail(body: PostUbsHealthPromotionSmsEmailRequest): Observable<ReturnStruct> {

    return this.httpClient.post<ReturnStruct>(environment.urlApiSrvEmail + "UbsHealthPromotionSmsEmail", body, this.addHeaderHashEmailSms())
      .pipe(
        catchError(this.handleError)
    )
  }
}
